 
export default {
	state: {
		map: null,
		layers: {},
		ws: {}
	},
	
	mutations: {
		setMap (state, map) {
			state.map = map;
		},
		
		initMap (state, initView = {}) {
			const { latLng, zoom } = Object.assign({
				latLng: [7, 40],
				zoom: 5
			}, initView);
			state.map.setView(latLng, zoom);
			state.map.invalidateSize();
		},
		
		addBaseLayers (state, tileLayers) {
			let control = {};
			tileLayers.forEach(layer => {
				let tile = L.tileLayer(layer.url, layer.options);
				tile.addTo(state.map);
				control[layer.title] = tile;
			});
			L.control.layers(control).addTo(state.map);
		},
		
		addLayer (state, payload) {
			payload.layer.addTo(state.map);
			state.layers[payload.token_id] = payload.layer;
		},
		
		appendToLayer (state, payload) {
			state.layers[payload.token_id].addLayer(payload.marker);
		},
		
		removeLayer (state, payload) {
			if (typeof payload == 'function') {
				Object.keys(state.layers)
				.filter(token_id => payload(token_id, state.layers[token_id]))
				.forEach(token_id => state.layers[token_id].remove());
			} else {
				if (payload.token_id) {
					const layer = state.layers[payload.token_id];
					if (layer) {
						layer.remove();
					}
				}
				if (payload.layer) {
					payload.layer.remove();
				}
			}
		},
		
		panTo (state, fix) {
			state.map.flyTo([fix.latitude, fix.longitude]);
		}
		
	},
	
	actions: {
		async tokenState ({commit, rootState}, payload) {
			commit('tokenState', payload);
			for (let token_id of payload) {
				try {
					const fixes = await rootState.api.getFixes(token_id);
					commit('setTokenFixes', { [token_id]: fixes });
				} catch (err) {
					console.log("Cannae fetch fixes");
				}
			}
		}
	},
	
	namespaced: false
};
 
